import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import {
  AnonymousStaffList,
  StaffListStatus,
} from "@/builders/types/staff-list";

const list = function (params?: FilterParams<{ status?: StaffListStatus }>) {
  return api
    .get<AnonymousStaffList>("staffs/type/anonymous", { params })
    .then(({ data }) => data);
};

const onboard_or_reject_anon_staff = function (variables: {
  id: number;
  data: { approve_onboarding: boolean };
}) {
  const { id, data } = variables;
  return api
    .post<{
      data: {
        message: string;
      };
    }>(`staffs/type/anonymous/${id}/onboard-or-reject-anon-staff`, data)
    .then(({ data }) => data);
};

export const type = {
  anonymous: {
    list,
    onboard_or_reject_anon_staff,
  },
};
